// Only the host is kept: referrer paths and queries can carry personal data.
// Lowercased with a leading www. and a trailing dot stripped, so www.LinkedIn.com.
// and linkedin.com match.
// URL parsing keeps characters such as & and = in hostnames (and in opaque hosts like
// android-app://), so anything that is not a plain DNS name is dropped rather than
// being written into a query string.
const PLAIN_HOST = /^[a-z0-9._-]+$/;

export const getReferrerHost = (referrer: string): string => {
  if (!referrer) return '';
  try {
    const host = new URL(referrer).hostname
      .toLowerCase()
      .replace(/^www\./, '')
      .replace(/\.$/, '');
    return PLAIN_HOST.test(host) ? host : '';
  } catch {
    return '';
  }
};
